var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.955,
    height: 21.955,
    viewBox: "0 0 21.955 21.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(-1577.324 -5394.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M1588.3,5396.663c2.931,0,3.278.012,4.436.064a6.085,6.085,0,0,1,2.038.378,3.644,3.644,0,0,1,2.084,2.084,6.091,6.091,0,0,1,.378,2.038c.052,1.158.063,1.5.063,4.436s-.011,3.278-.063,4.436a6.091,6.091,0,0,1-.378,2.038,3.648,3.648,0,0,1-2.084,2.084,6.1,6.1,0,0,1-2.038.378c-1.158.052-1.505.064-4.436.064s-3.279-.012-4.436-.064a6.092,6.092,0,0,1-2.038-.378,3.639,3.639,0,0,1-2.084-2.084,6.091,6.091,0,0,1-.378-2.038c-.052-1.158-.064-1.5-.064-4.436s.012-3.278.064-4.436a6.091,6.091,0,0,1,.378-2.038,3.636,3.636,0,0,1,2.084-2.084,6.079,6.079,0,0,1,2.038-.378c1.158-.052,1.505-.064,4.436-.064m0-1.977c-2.981,0-3.355.012-4.526.066a8.038,8.038,0,0,0-2.665.51,5.61,5.61,0,0,0-3.21,3.21,8.064,8.064,0,0,0-.511,2.665c-.053,1.171-.066,1.545-.066,4.526s.013,3.355.066,4.526a8.061,8.061,0,0,0,.511,2.665,5.614,5.614,0,0,0,3.21,3.21,8.06,8.06,0,0,0,2.665.511c1.171.053,1.545.066,4.526.066s3.355-.013,4.526-.066a8.071,8.071,0,0,0,2.665-.511,5.614,5.614,0,0,0,3.21-3.21,8.064,8.064,0,0,0,.51-2.665c.054-1.171.066-1.545.066-4.526s-.012-3.355-.066-4.526a8.066,8.066,0,0,0-.51-2.665,5.61,5.61,0,0,0-3.21-3.21,8.049,8.049,0,0,0-2.665-.51c-1.171-.054-1.545-.066-4.526-.066Z",
    fill: "#597931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M1588.3,5400.026a5.637,5.637,0,1,0,5.637,5.637A5.637,5.637,0,0,0,1588.3,5400.026Zm0,9.3a3.659,3.659,0,1,1,3.659-3.659A3.659,3.659,0,0,1,1588.3,5409.322Z",
    fill: "#597931"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 1.317,
    cy: 1.317,
    r: 1.317,
    transform: "translate(1592.844 5398.486)",
    fill: "#597931"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c5a89095d5b2e46def3de889bbb010b4.svg";
export { ForwardRef as ReactComponent };